export default "<input [formControl]=\"dateControl\" class=\"form-control\" type=\"month\" [max]=\"maxDate\" [min]=\"minDate\" />\n"